import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 10px 0px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../../utils/styling/styled-components';
import { SelectInputV3 } from '../SelectInputV3';
var StyledContainer = styled.div(_templateObject());
/* This wrapper component is used to conform FormBuilderV3's props with SelectInputV3 */

var SelectInputV3CompatibilityWrapper = function SelectInputV3CompatibilityWrapper(_ref) {
  var values = _ref.values,
      value = _ref.value,
      name = _ref.name,
      handleSelectChange = _ref.handleSelectChange,
      props = _objectWithoutProperties(_ref, ["values", "value", "name", "handleSelectChange"]);

  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(SelectInputV3, _extends({
    value: value ? value : values[name],
    name: name,
    onChange: handleSelectChange
  }, props)));
};

export { SelectInputV3CompatibilityWrapper };